import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import Chip from '@mui/material/Chip';
import ordinal from 'ordinal';
import { useCallback } from 'react';
import { shallowEqual } from 'react-redux';
import { useSocketSend } from '../../../../context/webSocket/webSocketContext';
import { PanelItem } from '../../../../panels/panelItem';
import { thunkShowPlayerInfo } from '../../../../redux/actions/playerInfoActions';
import { useAppDispatch, useAppSelector } from '../../../../redux/store';
import { ROOM_INFO_PANEL_LIST_ITEM_HOVER_COLOR } from '../../../../styles/colors';
import { getShortRenderedValueStr } from '../../../../utils/numberPrecisionUtils';
const MAIN_CONTENT_CSS = css `
  flex-grow: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
const RANK_CONTAINER_CSS = css `
  margin-right: 5px;
`;
export const TourneyStandingsPlayerDisplay = ({ playerType, playerIndex, showChips }) => {
    const tourneyStandingsPlayer = useAppSelector((state) => playerType === 'active' ? state.mtt.activePlayers[playerIndex] : state.mtt.finishedPlayers[playerIndex], shallowEqual);
    const dispatch = useAppDispatch();
    const socketSend = useSocketSend();
    const onClick = useCallback(() => {
        dispatch(thunkShowPlayerInfo(tourneyStandingsPlayer, socketSend));
    }, [dispatch, socketSend, tourneyStandingsPlayer]);
    if (!tourneyStandingsPlayer) {
        return null;
    }
    const { name, place, numChips } = tourneyStandingsPlayer;
    return (_jsxs(PanelItem, { hoverColor: ROOM_INFO_PANEL_LIST_ITEM_HOVER_COLOR, onClick: onClick, ariaLabel: name, children: [_jsxs("div", { css: MAIN_CONTENT_CSS, children: [_jsx("span", { css: RANK_CONTAINER_CSS, children: _jsx(Chip, { label: ordinal(place), variant: 'outlined', size: 'small' }) }), name] }), showChips && _jsx("span", { children: getShortRenderedValueStr(numChips) })] }));
};
